/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  circulatingSupplyGetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGet,
} from "../../funcs/circulatingSupplyGetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest$inboundSchema,
};

export const tool$circulatingSupplyGetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGet:
  ToolDefinition<typeof args> = {
    name:
      "circulating-supply-txt-v1",
    description: `Get the latest total supply value in plain text format.

Original tool name: circulating-supply-txt-get

### How is the data for this endpoint gathered?

Circulating supply is calculated by the following formula:

Total Supply = Sum of all mints - Sum of all burns
Circulating Supply = Total Supply - Sum of all balances of accounts to which tokens were minted before swap

Original tool name: get-circulating-supply-txt-ledger-canister-id-circulating-supply-txt-get`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await circulatingSupplyGetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };